import SpinnerBtn from '../spinner-btn/spinner-btn.vue';
import noop from 'lodash/noop';

export default {
   name: 'FilterInput',
   props: {
      text: {
         type: String
      },
      useAutoFocused: {
         type: Boolean,
         default: false
      },
      loading: {
         type: Boolean,
         default: false
      },
      alwaysShowClear: {
         type: Boolean,
         default: false
      },
      placeholder: {
         type: String,
         default: ''
      },
      showSearchIcon: {
         type: Boolean,
         default: true
      },
      disabled: {
         type: Boolean,
         default: false
      },
      onUpPressed: {
         type: Function,
         default: noop
      },
      onDownPressed: {
         type: Function,
         default: noop
      }
   },
   components: { SpinnerBtn },
   data() {
      return {
         filter: this.text
      };
   },
   computed: {
      isClearShowed() {
         return this.alwaysShowClear || !this.loading && this.filter !== '';
      }
   },
   methods: {
      clear() {
         this.filter = '';
         this.$nextTick(() => {
            this.$emit('clear');
            this.$emit('force');
         });
      },
      up(e) {
         if (this.onUpPressed() === false) {
            e.preventDefault();
            e.stopPropagation();
            return false;
         }
         return true;
      },
      down(e) {
         if (this.onDownPressed() === false) {
            e.preventDefault();
            e.stopPropagation();

            return false;
         }
         return true;
      }
   },
   mounted() {
      setTimeout(() => {
         if (this.useAutoFocused) {
            this.$refs.input.focus();
         }
      });
   },
   watch: {
      text(text) {
         this.filter = text;
      },
      filter(text, old) {
         this.$emit('change', text, old);
      }
   }
};
